import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Icon, Input, Button, message } from 'utils/ui';
import CreateGroup from './CreateGroup';
import NavViews from '../stores/NavViews';

@observer(["CustomRouter"])
class FirstGroupOnboarding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inviteLink: ""
        };

        this.handleInviteJoin = this.handleInviteJoin.bind(this);
        this.extractInviteId = this.extractInviteId.bind(this);
    }

    extractInviteId(rawValue) {
        const value = (rawValue || "").trim();
        if (!value) {
            return "";
        }

        const inviteFromPath = value.match(/\/invite\/([^/?#]+)/i);
        if (inviteFromPath && inviteFromPath[1]) {
            return inviteFromPath[1];
        }

        if (!value.includes("/") && !value.includes("?")) {
            return value;
        }

        return "";
    }

    handleInviteJoin() {
        const inviteId = this.extractInviteId(this.state.inviteLink);
        if (!inviteId) {
            message.warning("Paste a valid invite link or invite code.");
            return;
        }

        this.props.CustomRouter.router.goTo(NavViews.invitePage, { inviteId });
    }

    render() {
        return (
            <div
                className="AppFont"
                style={{
                    maxWidth: "720px",
                    margin: "30px auto",
                    backgroundColor: "rgba(255,255,255,0.14)",
                    borderRadius: "14px",
                    padding: "26px 24px",
                    color: "white",
                    boxShadow: "0 10px 24px rgba(0,0,0,0.14)"
                }}
            >
                <div style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "8px" }}>
                    Welcome! Let us set up your first group.
                </div>
                <div style={{ fontSize: "14pt", opacity: 0.95, marginBottom: "20px" }}>
                    Groups help you share gift ideas with friends and family. Choose one option below to continue.
                </div>

                <div style={{ textAlign: "left", marginBottom: "18px", lineHeight: 1.7 }}>
                    <div><Icon type="check-circle" style={{ marginRight: "8px" }} /> Step 1: Create a group for your family or friend circle.</div>
                    <div><Icon type="check-circle" style={{ marginRight: "8px" }} /> Step 2: Copy your invite link.</div>
                    <div><Icon type="check-circle" style={{ marginRight: "8px" }} /> Step 3: Share the link and start building wish lists together.</div>
                </div>

                <div style={{ display: "flex", justifyContent: "center", marginBottom: "16px" }}>
                    <CreateGroup />
                </div>

                <div style={{
                    marginTop: "16px",
                    paddingTop: "16px",
                    borderTop: "1px solid rgba(255,255,255,0.22)"
                }}>
                    <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Already have an invite link?
                    </div>
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
                        <Input
                            value={this.state.inviteLink}
                            onChange={(e) => this.setState({ inviteLink: e.target.value })}
                            placeholder="Paste invite link or invite code"
                            style={{ maxWidth: "420px" }}
                        />
                        <Button
                            type="primary"
                            onClick={this.handleInviteJoin}
                            style={{ borderRadius: "6px" }}
                        >
                            Join Group
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default FirstGroupOnboarding;
